import React, { useState } from 'react';
import { Modal } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';

type Props = {
  src: string;
  alt?: string;
  className?: string;
};

// Document image that opens fitted to the viewport when clicked.
const EnlargeableImage: React.FC<Props> = ({
  src,
  alt = 'Document',
  className
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-label={`Enlarge ${alt}`}
        onClick={() => setOpen(true)}
        className="group relative block w-full cursor-zoom-in rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      >
        <img src={src} alt={alt} className={clsx('w-full', className)} />
        <span className="pointer-events-none absolute inset-0 rounded-lg bg-black/0 transition-colors group-hover:bg-black/10" />
        <span className="pointer-events-none absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-full bg-black/60 text-white shadow">
          <OpenInFullIcon sx={{ fontSize: 16 }} />
        </span>
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        slotProps={{
          backdrop: { sx: { backgroundColor: 'rgba(0, 0, 0, 0.85)' } }
        }}
      >
        <div
          role="dialog"
          aria-modal="true"
          aria-label={alt}
          className="flex h-full w-full items-center justify-center p-4 outline-none"
          onClick={(e) => {
            if (e.target === e.currentTarget) setOpen(false);
          }}
        >
          <img
            src={src}
            alt={alt}
            className="max-h-[90vh] max-w-[95vw] cursor-default object-contain shadow-2xl"
          />
          <button
            type="button"
            aria-label="Close"
            onClick={() => setOpen(false)}
            className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/25 focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <CloseIcon />
          </button>
        </div>
      </Modal>
    </>
  );
};

export default EnlargeableImage;
